// extracted by mini-css-extract-plugin
export default {"tag_pula":"_404_tag_pula__dqO+0","content":"_404_content__CDoaX","bounce":"_404_bounce__AgLEJ"};